var y = Object.defineProperty;
var c = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var d = (t, o, e) => o in t ? y(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, l = (t, o) => {
  for (var e in o || (o = {}))
    f.call(o, e) && d(t, e, o[e]);
  if (c)
    for (var e of c(o))
      g.call(o, e) && d(t, e, o[e]);
  return t;
};
var a = (t, o) => {
  var e = {};
  for (var r in t)
    f.call(t, r) && o.indexOf(r) < 0 && (e[r] = t[r]);
  if (t != null && c)
    for (var r of c(t))
      o.indexOf(r) < 0 && g.call(t, r) && (e[r] = t[r]);
  return e;
};
import w, { forwardRef as M, useContext as N } from "react";
import { IconContext as P } from "./context.mjs";
const h = M((t, o) => {
  const m = t, {
    alt: e,
    color: r,
    size: n,
    weight: s,
    mirrored: p,
    children: u,
    weights: C
  } = m, v = a(m, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), x = N(P), {
    color: B = "currentColor",
    size: i,
    weight: I = "regular",
    mirrored: E = !1
  } = x, R = a(x, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ w.createElement(
    "svg",
    l(l({
      ref: o,
      xmlns: "http://www.w3.org/2000/svg",
      width: n != null ? n : i,
      height: n != null ? n : i,
      fill: r != null ? r : B,
      viewBox: "0 0 256 256",
      transform: p || E ? "scale(-1, 1)" : void 0
    }, R), v),
    !!e && /* @__PURE__ */ w.createElement("title", null, e),
    u,
    C.get(s != null ? s : I)
  );
});
h.displayName = "IconBase";
const b = h;
export {
  b as default
};
